import React, { useState, useEffect } from "react";
import {
  Chart,
  Settings,
  BarSeries,
  Axis,
  Position,
  Tooltip,
  DARK_THEME,
  LIGHT_THEME,
  ScaleType,
} from "@elastic/charts";
import Loader from "../../../shared/Loader";
import { useTheme } from "../../../../context/ThemeContext";
import StatsService from "../../../../services/v2/inbound/stats-service";

const DistributionByQueue = ({ filters }) => {
  const [data, setData] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const { isDarkMode } = useTheme();

  useEffect(() => {
    setLoading(true);
    setError(false);
    StatsService.distributionByQueue(filters)
      .then(({ data: { data } }) => {
        // Transformar los datos para adaptarlos a @elastic/charts
        const transformedData = [];
        data.forEach((callResult) => {
          callResult.queues.forEach((queue) => {
            transformedData.push({
              g: callResult.callResult, // Eje X - Resultados de llamada
              y: queue.count, // Altura de la barra
              x: queue.queueName, // Grupo (cola)
            });
          });
        });
        setData(transformedData);
        setLoading(false);
      })
      .catch((error) => {
        setError(true);
        setLoading(false);
      });
  }, [filters]);

  if (isLoading)
    return (
      <div className="flex items-center justify-center w-full h-full">
        <Loader />
      </div>
    );
  if (error)
    return (
      <div className="flex items-center justify-center w-full h-full">
        <div className="text-red-500 text-sm font-semibold text-center">
          Some error occurred loading data
        </div>
      </div>
    );

  return (
    <div className={`w-full h-full ${isDarkMode ? "dark-legend" : ""}`}>
      <Chart size="100%">
        <Settings
          showLegend={true}
          legendPosition="left"
          baseTheme={isDarkMode ? DARK_THEME : LIGHT_THEME}
          theme={{
            background: {
              color: isDarkMode ? "#1A202C" : "#ffffff",
            },
            axes: {
              tickLine: {
                stroke: isDarkMode ? "#ffffff" : "#000000",
              },
              tickLabel: {
                fill: isDarkMode ? "#ffffff" : "#000000",
              },
            },
          }}
        />
        <Tooltip
          style={{
            backgroundColor: isDarkMode ? "#1f2937" : "#ffffff",
            color: isDarkMode ? "#ffffff" : "#000000",
            border: `1px solid ${isDarkMode ? "#4B5563" : "#E5E7EB"}`,
          }}
        />
        <BarSeries
          id="distribution-by-queue"
          xScaleType={ScaleType.Ordinal}
          yScaleType={ScaleType.Linear}
          xAccessor="x" // Eje X
          yAccessors={["y"]} // Altura de las barras
          splitSeriesAccessors={["g"]} // Divide las series por cola
          stackAccessors={["x"]} // Apila por eje X (callResult)
          data={data}
        />
        <Axis
          id="bottom-axis"
          position={Position.Bottom}
          showOverlappingTicks
          tickLabelStyle={{
            fill: isDarkMode ? "#ffffff" : "#000000", // Etiquetas del eje X
          }}
        />
        <Axis
          id="left-axis"
          position={Position.Left}
          tickFormat={(d) => Number(d).toFixed(0)} // Formato de conteo
          tickLabelStyle={{
            fill: isDarkMode ? "#ffffff" : "#000000", // Etiquetas del eje Y
          }}
        />
      </Chart>
    </div>
  );
};

export default DistributionByQueue;
